<script>
import BlockContent from '../UI/Content/BlockContent.vue'
import mixinComponent from '../../Mixins/mixinComponent'
import dynamicFormUtil from '../../Mixins/dynamicFormUtil'
import { globalVariablesMixin } from '../../Mixins/global'
import DecisionList from './Decision/DecisionList.vue'

export default {
  components: { DecisionList, BlockContent },
  mixins: [mixinComponent, dynamicFormUtil, globalVariablesMixin],

  props: {
    simulationId: { type: Number, required: true },
    simulation: { type: Object, required: true },
    def: { type: Object, required: true },
  },

  data() {
    return {
      client: {},
    }
  },

  emits: ['call:alert', 'update-simulation'],

  methods: {
    demandSent(e) {
      for (const [index, dec] of Object.entries(this.simulation.decisions)) {
        if (dec.id == e.decisionOrg.id) {
          e.decisionOrg['demand'] = e
          this.setValue(this.simulation.decisions, index, e.decisionOrg)
        }
      }
      this.updateSimulation()
    },
    getDecisionIndexById(id) {
      return this.simulation.decisions.findIndex((dec) => dec.id == id)
    },
    messageSent(e) {
      let message = e.message
      let decisionIndex = this.getDecisionIndexById(e.decisionId)

      this.simulation.decisions[decisionIndex].demand.messages.unshift(message)
    },
    rentUpdated(e) {
      let rent = e.rent
      let decisionIndex = this.getDecisionIndexById(e.decisionId)

      let rentIndex = this.simulation.decisions[decisionIndex].rents.findIndex((curRent) => curRent.id == rent.id)
      this.simulation.decisions[decisionIndex].rents[rentIndex] = {
        ...this.simulation.decisions[decisionIndex].rents[rentIndex],
        ...rent,
      }
    },
    getAlert() {
      this.$emit('call:alert')
    },
    updateSimulation() {
      this.$emit('update-simulation', true)
    },
  },

  beforeMount() {
    if (!this.hasRole('ROLE_DEMAND')) {
      location.href = '/'
    }

    this.getJSON('quotations/' + this.simulationId + '/scoreclient').then((client) => {
      this.client = client
    })
  },
}
</script>
<template>
  <div>
    <DecisionList
      v-if="Object.entries(def).length > 0"
      :simulation-def="def"
      :simulation="simulation"
      :client="client"
      @message-sent="messageSent"
      @demand-sent="demandSent"
      @update-simulation="updateSimulation"
      @call:alert="getAlert"
    />

    <div class="row" v-else>
      <div class="col-md-6">
        <BlockContent>
          <div class="row py-3 mb-3 mx-3 loading"></div>
          <div class="row py-3 mb-3 mx-3 loading"></div>
          <div class="my-4" style="border-bottom: 1px solid #eee"></div>
          <div class="row py-3 mb-3 mx-3 loading"></div>
          <div class="row py-3 mb-3 mx-3 loading"></div>
        </BlockContent>
      </div>
      <div class="col-md-6">
        <BlockContent>
          <div class="row py-3 mb-3 mx-3 loading"></div>
          <div class="row py-3 mb-3 mx-3 loading"></div>
          <div class="row py-3 mb-3 mx-3 loading"></div>
          <div class="row py-3 mb-3 mx-3 loading"></div>
        </BlockContent>
      </div>
    </div>
  </div>
</template>
